import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TeamPage: React.FC = () => {
  const teamMembers = [
    {
      name: "Florence Tercier",
      image: "/images/team/Florence Headshot.jpeg",
      title: "Co-Founder\nGlobal Development & Strategic Partnerships",
      slug: "florence"
    },
    {
      name: "Cristian Correa",
      image: "/images/team/Cristian-Correa-Headshot.jpg",
      title: "Co-Founder\nScience & Innovation Lead",
      slug: "cristian"
    },
    {
      name: "Emiliano Pereira",
      image: "/images/team/Emiliano-Pereira-Headshot.jpg",
      title: "Co-Founder\nBioinformatics & Genomics",
      slug: "emiliano"
    },
    {
      name: "Semidán Robaina",
      image: "/images/team/Semidan-Robaina-Headshot.jpeg",
      title: "Co-Founder\nAI & Computational Biology",
      slug: "semidan"
    },
    {
      name: "Josh L. Espinoza",
      image: "/images/team/Josh-L-Espinoza-Headshot.jpg",
      title: "Bioinformatics & Engineering",
      slug: "josh"
    },
    {
      name: "Florence Perramond",
      image: "/images/team/Florence-Perramond_Headshot.jpeg",
      title: "Investments & Business Development",
      slug: "florence_perramond"
    },
    {
      name: "Torsten Thiele",
      image: "/images/team/Torsten-Thiele.jpg",
      title: "Blue Finance Advisor",
      slug: "torsten"
    },
    {
      name: "Gerald Page",
      image: "/images/team/Gerald-Page.png",
      title: "Market Architect Advisor",
      slug: "gerald"
    },
    {
      name: "Steve Sperandeo",
      image: "/images/team/Steve-Sperandeo-Headshot.jpg",
      title: "AI Systems Architect",
      slug: "steve"
    },
    {
      name: "Kaylan Holst-Roness",
      image: "/images/team/Kaylan-Holst-Roness-Headshot.jpg",
      title: "Business Advisor",
      slug: "kaylan"
    }
  ];

  useEffect(() => {
    // Always scroll to top when this page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header isMainPage={false} />

      <main className="flex-grow-1">
        <section className="team py-5" style={{
          marginTop: '60px',
          position: 'relative'
        }}>
          <style>
            {`.team::before { display: none; }
             @media (max-width: 767.98px) {
               .team-row-first { margin-bottom: 2rem !important; }
               .team-member-mobile { margin-bottom: 2rem !important; }
             }`}
          </style>
          <div className="container">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8 text-center">
                <h1 style={{
                  fontSize: 'clamp(2rem, 5vw, 3rem)',
                  fontWeight: 700,
                  marginBottom: '2rem',
                  letterSpacing: '-0.02em',
                  lineHeight: 1.2,
                  color: '#EFEFE3',
                  fontFamily: "'Montserrat', sans-serif"
                }}>
                  Team
                </h1>
                <p className="lead mb-5" style={{
                  fontSize: '1.2rem',
                  color: '#D5D6CC',
                  lineHeight: '1.6'
                }}>
                  Ocean BioMetrics' transdisciplinary team is a unique combination of world-class scientific expertise, advanced technological capabilities, sustainable business management, and ocean conservation finance experience. Building on three years of pioneering R&D at our predecessor, NewAtlantis Labs, we have acquired all the scientific and technological assets co-developed by our founding team and expanded our capabilities with specialized expertise in investment and business development.
                </p>
              </div>
            </div>

            {/* First row with 4 co-founders */}
            <div className="row justify-content-center mb-5 team-row-first">
              {teamMembers.slice(0, 4).map((member, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 text-center team-member-mobile">
                  <Link to={`/team/${member.slug}`} className="team-member-link" style={{ textDecoration: 'none' }}>
                    <img
                      src={member.image}
                      className="circular-headshot mb-3"
                      alt={member.name}
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #0888D0',
                        transition: 'all 0.4s ease',
                        boxShadow: '0 0 20px rgba(8, 136, 208, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.08) translateY(-5px)';
                        e.currentTarget.style.borderColor = '#18C3BA';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(24, 195, 186, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1) translateY(0)';
                        e.currentTarget.style.borderColor = '#0888D0';
                        e.currentTarget.style.boxShadow = '0 0 20px rgba(8, 136, 208, 0.2)';
                      }}
                    />
                    <h4 style={{
                      fontSize: '1.25rem',
                      fontWeight: 600,
                      marginBottom: '0.5rem',
                      lineHeight: 1.4,
                      whiteSpace: 'pre-line'
                    }}>
                      {member.name}
                    </h4>
                    <p className="fs-6" style={{
                      fontStyle: 'italic',
                      margin: 0,
                      color: '#18C3BA',
                      fontWeight: 500,
                      whiteSpace: 'pre-line'
                    }}>
                      {member.title}
                    </p>
                  </Link>
                </div>
              ))}
            </div>

            {/* Second row with 2 team members centered */}
            <div className="row justify-content-center">
              {teamMembers.slice(4).map((member, index) => (
                <div key={index + 4} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 text-center team-member-mobile">
                  <Link to={`/team/${member.slug}`} className="team-member-link" style={{ textDecoration: 'none' }}>
                    <img
                      src={member.image}
                      className="circular-headshot mb-3"
                      alt={member.name}
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #0888D0',
                        transition: 'all 0.4s ease',
                        boxShadow: '0 0 20px rgba(8, 136, 208, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.08) translateY(-5px)';
                        e.currentTarget.style.borderColor = '#18C3BA';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(24, 195, 186, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1) translateY(0)';
                        e.currentTarget.style.borderColor = '#0888D0';
                        e.currentTarget.style.boxShadow = '0 0 20px rgba(8, 136, 208, 0.2)';
                      }}
                    />
                    <h4 style={{
                      fontSize: '1.25rem',
                      fontWeight: 600,
                      marginBottom: '0.5rem',
                      lineHeight: 1.4,
                      whiteSpace: 'pre-line'
                    }}>
                      {member.name}
                    </h4>
                    <p className="fs-6" style={{
                      fontStyle: 'italic',
                      margin: 0,
                      color: '#18C3BA',
                      fontWeight: 500,
                      whiteSpace: 'pre-line'
                    }}>
                      {member.title}
                    </p>
                  </Link>
                </div>
              ))}
            </div>

            <div className="text-center mt-5 pt-4">
              <p className="mb-3" style={{ fontSize: '1.1rem', color: '#D5D6CC' }}>
                Interested in joining our team or learning more about our expertise?
              </p>
              <a href="/#contact" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1rem 2.5rem',
                background: 'linear-gradient(135deg, rgba(24, 195, 186, 0.15) 0%, rgba(24, 195, 186, 0.25) 100%)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(24, 195, 186, 0.3)',
                borderRadius: '50px',
                color: '#18C3BA',
                textDecoration: 'none',
                fontSize: '1.1rem',
                fontWeight: 600,
                fontFamily: "'Montserrat', sans-serif",
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 8px 25px rgba(24, 195, 186, 0.15)',
                position: 'relative',
                overflow: 'hidden'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, rgba(24, 195, 186, 0.25) 0%, rgba(24, 195, 186, 0.35) 100%)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(24, 195, 186, 0.25)';
                  e.currentTarget.style.borderColor = 'rgba(24, 195, 186, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, rgba(24, 195, 186, 0.15) 0%, rgba(24, 195, 186, 0.25) 100%)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(24, 195, 186, 0.15)';
                  e.currentTarget.style.borderColor = 'rgba(24, 195, 186, 0.3)';
                }}
              >
                <span>Get in Touch</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  style={{
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <path
                    d="M7 17L17 7M17 7H7M17 7V17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TeamPage;